<atx-input-with-icon
  [icon]="['fas', 'magnifying-glass']"
  [formControl]="searchControl"
  [loading]="isLoading"
  [debounceTime]="debounceTime"
  [updateOnEvents]="true"
  [ignoreConsequentInputs]="noResult"
  [placeholderText]="placeholderText"
  data-e2e="search-order-book-input"
  size="lg"
></atx-input-with-icon>
@if (showClearIcon()) {
<fa-icon
  class="delete-icon"
  [icon]="['fas', 'xmark']"
  size="xs"
  (click)="searchControl.setValue('')"
></fa-icon>
}
